var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.loading)?_c('v-chip',{attrs:{"color":_vm.chipColor,"text-color":_vm.chipTextColor,"label":"","small":""}},[_vm._v("\n    "+_vm._s(_vm.value)+"\n  ")]):_c('v-progress-circular',{attrs:{"size":20,"width":3,"indeterminate":"","color":"primary"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02b1cdca","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chips/StockChip.vue
// module id = null
// module chunks = 